const Genres = {
  AFROBEAT: "Afrobeat",
  ALTERNATIVE_ROCK: "Alternative Rock",
  AMBIENT: "Ambient",
  BOUNCE: "Bounce",
  CLASSICAL: "Classical",
  COUNTRY: "Country",
  DANCE_EDM: "Dance & EDM",
  DANCEHALL: "Dancehall",
  DEEP_HOUSE: "Deep House",
  DISCO: "Disco",
  DOWNTEMPO: "Downtempo",
  DRUM_BASS: "Drum & Bass",
  DUBSTEP: "Dubstep",
  ELECTRONIC: "Electronic",
  EXPERIMENTAL: "Experimental",
  FOLK_SINGER_SONGWRITER: "Folk & Singer-Songwriter",
  HIP_HOP_RAP: "Hip-hop & Rap",
  HOUSE: "House",
  HYPERPOP: "Hyperpop",
  INDIE: "Indie",
  JAZZ_BLUES: "Jazz & Blues",
  LATIN: "Latin",
  LOFI: "Lofi",
  METAL: "Metal",
  PIANO: "Piano",
  POP: "Pop",
  R_B_SOUL: "R&B & Soul",
  REGGAE: "Reggae",
  REGGAETON: "Reggaeton",
  ROCK: "Rock",
  SOUNDTRACK: "Soundtrack",
  TECHNO: "Techno",
  TRANCE: "Trance",
  TRAP: "Trap",
  TRIPHOP: "Triphop",
  WORLD: "World"
};
const GENRE_NAMES = Object.values(Genres);
const GenreNameToKey = {
  Afrobeat: "AFROBEAT",
  "Alternative Rock": "ALTERNATIVE_ROCK",
  Ambient: "AMBIENT",
  Bounce: "BOUNCE",
  Classical: "CLASSICAL",
  Country: "COUNTRY",
  "Dance & EDM": "DANCE_EDM",
  Dancehall: "DANCEHALL",
  "Deep House": "DEEP_HOUSE",
  Disco: "DISCO",
  Downtempo: "DOWNTEMPO",
  "Drum & Bass": "DRUM_BASS",
  Dubstep: "DUBSTEP",
  Electronic: "ELECTRONIC",
  Experimental: "EXPERIMENTAL",
  "Folk & Singer-Songwriter": "FOLK_SINGER_SONGWRITER",
  "Hip-hop & Rap": "HIP_HOP_RAP",
  House: "HOUSE",
  Hyperpop: "HYPERPOP",
  Indie: "INDIE",
  "Jazz & Blues": "JAZZ_BLUES",
  Latin: "LATIN",
  Lofi: "LOFI",
  Metal: "METAL",
  Piano: "PIANO",
  Pop: "POP",
  "R&B & Soul": "R_B_SOUL",
  Reggae: "REGGAE",
  Reggaeton: "REGGAETON",
  Rock: "ROCK",
  Soundtrack: "SOUNDTRACK",
  Techno: "TECHNO",
  Trance: "TRANCE",
  Trap: "TRAP",
  Triphop: "TRIPHOP",
  World: "WORLD"
};
const GENRE_KEYS = Object.values(GenreNameToKey);
const GenreKey = {
  AFROBEAT: "AFROBEAT",
  ALTERNATIVE_ROCK: "ALTERNATIVE_ROCK",
  AMBIENT: "AMBIENT",
  BOUNCE: "BOUNCE",
  CLASSICAL: "CLASSICAL",
  COUNTRY: "COUNTRY",
  DANCE_EDM: "DANCE_EDM",
  DANCEHALL: "DANCEHALL",
  DEEP_HOUSE: "DEEP_HOUSE",
  DISCO: "DISCO",
  DOWNTEMPO: "DOWNTEMPO",
  DRUM_BASS: "DRUM_BASS",
  DUBSTEP: "DUBSTEP",
  ELECTRONIC: "ELECTRONIC",
  EXPERIMENTAL: "EXPERIMENTAL",
  FOLK_SINGER_SONGWRITER: "FOLK_SINGER_SONGWRITER",
  HIP_HOP_RAP: "HIP_HOP_RAP",
  HOUSE: "HOUSE",
  HYPERPOP: "HYPERPOP",
  INDIE: "INDIE",
  JAZZ_BLUES: "JAZZ_BLUES",
  LATIN: "LATIN",
  LOFI: "LOFI",
  METAL: "METAL",
  PIANO: "PIANO",
  POP: "POP",
  R_B_SOUL: "R_B_SOUL",
  REGGAE: "REGGAE",
  REGGAETON: "REGGAETON",
  ROCK: "ROCK",
  SOUNDTRACK: "SOUNDTRACK",
  TECHNO: "TECHNO",
  TRANCE: "TRANCE",
  TRAP: "TRAP",
  TRIPHOP: "TRIPHOP",
  WORLD: "WORLD"
};
function parseGenreCaseInsensitive(genreString) {
  const genreStringLowercase = genreString.toLowerCase();
  for (const genre of GENRE_NAMES) {
    if (genre.toLowerCase() === genreStringLowercase)
      return genre;
  }
  for (const genreKey of GENRE_KEYS) {
    if (genreKey.toLowerCase() === genreStringLowercase)
      return Genres[genreKey];
  }
  return null;
}
function genreKeysToNames(genreKeys) {
  return (genreKeys == null ? void 0 : genreKeys.map((genreKey) => Genres[genreKey]).filter(Boolean)) ?? [];
}

export { GENRE_KEYS, GENRE_NAMES, GenreKey, GenreNameToKey, Genres, genreKeysToNames, parseGenreCaseInsensitive };
